<button nz-button class="btn-error" [disabled]="disabled" [nzLoading]="loading" [nzBlock]="block">
  <img class="m-r-1" src="../../../assets/images/delete-button.svg" [alt]="alt" />
  <span *ngIf="label">{{ label }}</span>
  <ng-content></ng-content>
</button>
